'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slateEditTable = require('@gitbook/slate-edit-table');

var _slateEditTable2 = _interopRequireDefault(_slateEditTable);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _SlateEditTable$chang = (0, _slateEditTable2.default)().changes,
    insertRow = _SlateEditTable$chang.insertRow,
    removeRow = _SlateEditTable$chang.removeRow,
    removeTable = _SlateEditTable$chang.removeTable;


var TableToolbarMenu = function TableToolbarMenu(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'small',
      null,
      'Edit Table'
    ),
    _react2.default.createElement(_ToolbarButton2.default, { icon: 'plus', text: 'Add Row', onMouseDown: function onMouseDown(e) {
        return onChange(insertRow(value.change()));
      } }),
    _react2.default.createElement(_ToolbarButton2.default, { icon: 'minus', text: 'Remove Row', onMouseDown: function onMouseDown(e) {
        return onChange(removeRow(value.change()));
      } }),
    _react2.default.createElement(_ToolbarButton2.default, { icon: 'trash', text: 'Remove Table', onMouseDown: function onMouseDown(e) {
        return onChange(removeTable(value.change()));
      } })
  );
};

TableToolbarMenu.propTypes = {
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};
exports.default = TableToolbarMenu;